export default __webpack_public_path__ + "static/media/whatsApp-Logo.1ab869b2.svg";